
import {ref} from 'vue'

const SKIPPED_TEXT = 'Skipped...'

export default {
  props: {
    disabled: {type: Boolean, default: false},
    answer: {type: Object, default: undefined},
    query: {type: Object, default: undefined},
    skip: {type: Object, default: undefined},
    skipAll: {type: Object, default: undefined},
  },
  emits: ['prompt'],
  setup(){
    return {
      input: ref()
    }
  },
  data(){
    return {
      text: '',
      // TODO: In onboarding answer is not saved, so we need 
      // to use answered to track user interaction
      // Should be removed after onboarding is refactored to 
      // save answers in the history
      answered: false,
      placeholder: 'Enter Your Answer'
    }
  },
  computed:{
    can_confirm() {
      if (!this.text) return false
      return this.input.valid
    },
  },
  watch: {
    'answer': {
      handler: function(newValue) {
        if (newValue) {
          this.text = newValue.censored_input?.text || newValue.text
          if (!this.text) this.placeholder = SKIPPED_TEXT
          this.answered = true
        }
      },
      immediate: true
    },
  },
  methods: {
    onConfirm() {
      if (this.can_confirm) {
        this.answered = true
        this.$emit('prompt', {...(this.query || {}), text: this.text})
      }
    },

    onSkip(){
      this.answered = true
      this.text = ''
      this.placeholder = SKIPPED_TEXT
      this.$emit('prompt', this.skip.chat_query || {})
    },

    onSkipAll(){
      this.answered = true
      this.text = ''
      this.placeholder = SKIPPED_TEXT
      this.$emit('prompt', this.skipAll.chat_query || {})
    }
  }
}
